'use strict';

var util = require('../../util/util');
var StyleLayer = require('../style_layer');

function CircleStyleLayer() {
    StyleLayer.apply(this, arguments);
}

module.exports = CircleStyleLayer;

CircleStyleLayer.prototype = util.inherit(StyleLayer, {});



/*****************
 ** WEBPACK FOOTER
 ** ./~/mapbox-gl/js/style/style_layer/circle_style_layer.js
 ** module id = 836
 ** module chunks = 0
 **/